'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.schemes = exports.palette = exports.randomColor = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _all, _SCHEMES, _mutatorMap;

var _d3ScaleChromatic = require('d3-scale-chromatic');

var d3ScaleChromatic = _interopRequireWildcard(_d3ScaleChromatic);

var _d3Color = require('d3-color');

var _d3Scale = require('d3-scale');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // TODO categorical, adding multiple palettes together,
// finding difference of colours, github pagesds


var CATEGORICAL = 'categorical';
var DIVERGING = 'diverging';
var SEQUENTIAL = 'sequential';

var SCHEMES = (_SCHEMES = {}, _defineProperty(_SCHEMES, CATEGORICAL, ['Category10', 'Accent', 'Dark2', 'Paired', 'Pastel1', 'Pastel2', 'Set1', 'Set2', 'Set3']), _defineProperty(_SCHEMES, DIVERGING, ['BrBG', 'PRGn', 'PiYG', 'PuOr', 'RdBu', 'RdGy', 'RdYlBu', 'RdYlGn', 'Spectral']), _defineProperty(_SCHEMES, SEQUENTIAL, ['Blues', 'Greens', 'Greys', 'Oranges', 'Purples', 'Reds', 'BuGn', 'BuPu', 'GnBu', 'OrRd', 'PuBu', 'PuRd', 'RdPu', 'YlGnBu', 'YlGn', 'YlOrBr', 'YlOrRd', 'PuBuGn']), _all = 'all', _mutatorMap = {}, _mutatorMap[_all] = _mutatorMap[_all] || {}, _mutatorMap[_all].get = function () {
  return this.sequential.concat(this.diverging.concat(this.categorical));
}, _defineEnumerableProperties(_SCHEMES, _mutatorMap), _SCHEMES);

var randomColor = exports.randomColor = function randomColor(luminosity) {
  var letters = '0123456789ABCDEF';
  var color = '#';
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  if (luminosity) {
    color = (0, _d3Color.hsl)(color);
    color.l = luminosity;
    return '' + color;
  }
  return color;
};

var palette = exports.palette = function palette(params) {
  if (params.scheme) {
    return function (i) {
      var scheme = d3ScaleChromatic['scheme' + params.scheme];
      return SCHEMES[CATEGORICAL].includes(params.scheme) ? scheme.slice(0, i) : scheme[i];
    };
  }

  var opts = _extends({
    type: SEQUENTIAL
  }, params);

  var boundScale = (0, _d3Scale.scaleLinear)().domain([1, 8]).range([0.25, 0.5]);
  var getLowerBound = function getLowerBound(count) {
    return 0.5 - Math.min(0.5, boundScale(count));
  };

  var scale = (0, _d3Scale.scaleLinear)();
  var range = void 0;

  if (opts.type === DIVERGING) {
    if (opts.type === DIVERGING) opts.colors = [randomColor(0.25), randomColor(0.25)];
    range = opts.colors.reduce(function (acc, color) {
      return acc.concat([color, 'white']);
    }, []);
    range.pop();
  } else {
    if (!opts.colors) opts.colors = [randomColor(0.9), randomColor(0.25)];
    range = opts.colors;
  }
  scale.range(range);

  return function (count) {
    var domain = [];
    var rangeLength = range.length;
    var domainIntervalFromRangeLength = 1 / (rangeLength - 1);
    var domainIntervalFromMinLength = opts.minLength ? 1 / (count / opts.minLength) : 0;
    var domainInterval = Math.max(domainIntervalFromRangeLength, domainIntervalFromMinLength);
    for (var i = 0; i < rangeLength; i++) {
      domain.push(domainInterval * i);
    }
    scale.domain(domain);

    var oddCount = count % 2 === 0 ? count + 1 : count;
    var lowerBound = getLowerBound(oddCount);
    var colorsInterval = 1 / Math.max(oddCount - 1, 1);
    var colors = [];
    for (var _i = 0; _i < count; _i++) {
      colors.push(scale(lowerBound + colorsInterval * _i));
    }
    return colors;
  };
};

exports.schemes = SCHEMES;


//////////////////
// WEBPACK FOOTER
// ./~/@potion/color/lib/index.js
// module id = 203
// module chunks = 109508717676192